import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$g = ".MainContainer_module_container__d1278a0c{background-color:var(--st-background);border:1px solid var(--st-container-border);border-radius:var(--st-container-radius);color:var(--st-foreground);max-width:var(--st-container-width);padding:var(--st-spacing-10) var(--st-spacing-9);width:100%}.MainContainer_module_watermarkContainer__d1278a0c{display:flex;justify-content:center}";
collectCss(css$g);
var modules_852c89cd = {"container":"MainContainer_module_container__d1278a0c Root_module_root__870c11a1","watermarkContainer":"MainContainer_module_watermarkContainer__d1278a0c"};

export { css$g as css, modules_852c89cd as default };
//# sourceMappingURL=MainContainer.module.css.mjs.map
